import React from 'react'
import { useNavigate } from 'react-router-dom';


const SearchBar = (setSelectedMenu) => {
    const navigate = useNavigate();
    const handleRoute = (route, name, subtitle) => {
        navigate(route);
        setSelectedMenu({ title: name, subtitle });
      };
  return (
    <div className='py-3 px-10'>
      <h1 className="text-2xl font-semibold text-[#012949] mb-5">Plans Management</h1>
      <div className="flex justify-between md:flex-row flex-col">
        <div className="relative">
          <div className="absolute inset-y-0 start-0 flex justify-center items-center ps-3 pointer-events-none">
            <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
            </svg>
          </div>
          <input
            type="search"
            id="default-search"
            className="block w-full sm:w-[300px] md:w-[400px] lg:w-[500px] h-[40px] p-4 mt-1 ps-10 text-sm text-gray-900 border border-gray-300 rounded-full bg-gray-50 outline-none"
            placeholder="Search..."
            required
          />
        </div>
        <div>
          <button
            type="button"
            className='lg:w-[160px] text-nowrap w-full md:mt-0 mt-4 h-[46px] bg-orangeColor rounded-[10px] font-inter text-base font-bold text-white '
            onClick={() => navigate('/create-module')}
          >
            Create Module
          </button>
        </div>
      </div>
    </div>
  )
}

export default SearchBar
